import styled from 'styled-components/macro';
import { RegularTextLevel4 } from '@yme/tokens/typography';
export const DescriptionStyled = styled(RegularTextLevel4) `
  word-break: break-all;
`;
